import { FC, JSX, useState } from 'react';

import Input from '@semcore/input';
import HashtagM from '@semcore/ui/icon/Hashtag/m';

const defaultColors = [
  '#FF6900',
  '#FCB900',
  '#7BDCB5',
  '#00D084',
  '#8ED1FC',
  '#0693E3',
  '#ABB8C3',
  '#EB144C',
  '#F78DA7',
  '#9900EF',
];

const isValidHex = (hex: string) =>
  /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
const normalizeHex = (hex: string): string =>
  hex.startsWith('#') ? hex.substring(1) : hex;

interface IColorPickerProps {
  value?: string;
  onChange: (...event: unknown[]) => void;
}

const ColorPicker: FC<IColorPickerProps> = ({
  value,
  onChange,
}): JSX.Element => {
  const [isError, setIsError] = useState(false);
  const [currentValue, setCurrentValue] = useState<string>(
    normalizeHex(value ?? '')
  );
  const onColorChange = (color: string) => {
    const hex = `#${color}`;

    if (isValidHex(hex)) {
      onChange(hex);
      setIsError(false);
    } else {
      setIsError(true);
    }

    setCurrentValue(color);
  };

  return (
    <div className="relative mt-2 flex max-w-[170px] flex-col gap-1 rounded-lg bg-white shadow">
      <div
        className="absolute -top-[10px] left-1/2 -ms-[10px] h-0 w-0 border-solid"
        style={{
          borderWidth: '0 10px 10px',
          borderColor: `transparent transparent ${value}`,
        }}
      />
      <div
        className="relative flex h-[110px] w-[170px] items-center justify-center rounded-t-md "
        style={{ background: value }}
      >
        <div className="relative text-lg text-white">{value}</div>
      </div>
      <div className="flex flex-wrap gap-2.5 p-2.5">
        {defaultColors.map((color) => (
          <div
            className="h-[22px] w-[22px] cursor-pointer rounded"
            key={color}
            style={{ background: color }}
            onClick={() => {
              onChange(color);
              setIsError(false);
              setCurrentValue(normalizeHex(color));
            }}
          />
        ))}
      </div>
      <div className="flex flex-col p-2.5 pt-0">
        <Input
          size="m"
          state={isError ? 'invalid' : 'normal'}
          className="outline-none"
        >
          <Input.Addon
            style={{
              background: 'lightgray',
              borderRadius: '8px 0 0 8px',
              color: 'gray',
            }}
          >
            <HashtagM />
          </Input.Addon>
          <Input.Value
            pl={2}
            disabled={false}
            placeholder="FFFFFF"
            readOnly={false}
            onChange={onColorChange}
            value={currentValue}
          />
        </Input>
        {isError && (
          <div className="pt-1 text-center text-sm text-red">Invalid input</div>
        )}
      </div>
    </div>
  );
};

export default ColorPicker;
